export default "__VITE_ASSET__a745f53a__"